import styled from "styled-components";

export const Container = styled.div`
    padding: ${props => props.theme.spacing.xSmall};
`;

export const CalloutContainer = styled.div<{ backgroundColor?: string }>`
    padding: ${props => props.theme.spacing.small};
    background-color: ${props => props.backgroundColor || "rgba(240, 240, 245)"};
    border-radius: ${props => props.theme.cornerRadius.small} ${props => props.theme.cornerRadius.small} 0 0;
`;
